<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartdata: null
  },
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            stacked: true
          }
        ],
        xAxes: [
          {
            stacked: true
          }
        ]
      }
    }
  }),
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  watch: {
    chartdata: function() {
      this.$data._chart.update();
    }
  }
};
</script>
